// ─────────────────────────────────────────────────────────────────────────────
// OverviewTab.js — two featured cards (Uptime · IP), a 2×2 stat grid (Latency /
// Load / Trust / Connected Users), then the SYSTEM METRICS bars (CPU / Memory /
// Bandwidth). All values come from the view-model; this tab is pure layout.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "../NodeDetailModal.module.css";
import { ICONS } from "../icons";

export default function OverviewTab({ detail }) {
  const { featured, stats, metrics } = detail;

  return (
    <div className={styles.tab}>
      {/* ── featured cards ── */}
      <div className={styles.featuredGrid}>
        {featured.map((f) => {
          const Icon = ICONS[f.icon];
          return (
            <div key={f.key} className={styles.featuredCard}>
              <div className={styles.featuredHead}>
                {Icon && <span className={styles.featuredIcon}><Icon /></span>}
                <span className={styles.featuredLabel}>{f.label}</span>
              </div>
              <span className={`${styles.featuredValue} ${f.mono ? styles.mono : ""}`}>
                {f.value}
              </span>
            </div>
          );
        })}
      </div>

      {/* ── compact stat grid ── */}
      <div className={styles.statGrid}>
        {stats.map((s) => (
          <div key={s.key} className={styles.statCard}>
            <span className={styles.statLabel}>{s.label}</span>
            <span className={styles.statValue}>{s.value}</span>
          </div>
        ))}
      </div>

      {/* ── system metrics ── the section only exists if the node reported
          something to put in it (see buildNodeDetail) ── */}
      {metrics.length > 0 && (
        <>
      <div className={styles.sectionLabel}>System Metrics</div>
      <div className={styles.metricList}>
        {metrics.map((m) => {
          const Icon = ICONS[m.icon];
          return (
            <div key={m.key} className={styles.metricRow}>
              <div className={styles.metricTop}>
                <span className={styles.metricLabel}>
                  {Icon && <span className={styles.metricIcon}><Icon /></span>}
                  {m.label}
                </span>
                <span className={styles.metricValue}>{m.value}</span>
              </div>
              <div className={styles.bar}>
                <span className={styles.barFill} style={{ width: `${m.pct}%` }} />
              </div>
            </div>
          );
        })}
      </div>
        </>
      )}
    </div>
  );
}
